// third-party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import http from "../../http-common";
import { dispatch } from "../index";
// ----------------------------------------------------------------------

const initialState = {
  error: null,
  denunciaDados: [],
  denunciaDadosPorCodegrupodenuncia: [],
  denunciaDadosActividades: [],
  denunciaOneUser: [],
  notificacaoSuccess: [],
};

const slice = createSlice({
  name: "denuncias",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    getNotificacaosSuccess(state, action) {
      state.notificacaoSuccess = action.payload;
    },

    // GET DENUNCIAS
    getDenuncia(state, action) {
      state.denunciaDados = action.payload;
    },

    getDenunciaActividade(state, action) {
      state.denunciaDadosActividades = action.payload;
    },

    getDenunciaPorCodigoDenuncia(state, action) {
      state.denunciaDadosPorCodegrupodenuncia = action.payload;
    },

    setDenunciaOneUser(state, action) {
      state.denunciaOneUser = action.payload;
    },
  },
});

// Reducer
 export default slice.reducer;

// ----------------------------------------------------------------------

export function getAllDenuncia(tipoImpressao, sedeID, tipoMovimentodenuncia, tipoMovimento) {
  return async () => {
    try {
        const response = await http.get(`/denuncias?tipoImpressao=${tipoImpressao}&sedeID=${sedeID}&tipoMovimentodenuncia=${tipoMovimentodenuncia}&tipoMovimento=${tipoMovimento}`);
        dispatch(slice.actions.getDenuncia(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllDenunciaPorCodigoDenuncia(tipoImpressao, sedeID, codegrupodenuncia, tipoMovimentodenuncia, tipoMovimento) {
  return async () => {
    try {
        const response = await http.get(`/denunciasTratamento?tipoImpressao=${tipoImpressao}&sedeID=${sedeID}&codegrupodenuncia=${codegrupodenuncia}&tipoMovimentodenuncia=${tipoMovimentodenuncia}&tipoMovimento=${tipoMovimento}`);
        dispatch(slice.actions.getDenunciaPorCodigoDenuncia(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllDenunciaActividade(sedeID, codegrupodenuncia, tipoImpressao) {
  return async () => {
    try {
        const response = await http.get(`/DenunciaActividade?sedeID=${sedeID}&codegrupodenuncia=${codegrupodenuncia}&tipoImpressao=${tipoImpressao}`);
        dispatch(slice.actions.getDenunciaActividade(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function tipoReclamacaoGravar(data) {
  return async () => {
    try {
      const response = await http.post("/tipoDenuncia", data);

      dispatch(slice.actions.getNotificacaosSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function tipoReclamacaoNivel2Gravar(data) {
  return async () => {
    try {
      const response = await http.post("/tipoDenunciaNivel2", data);

      dispatch(slice.actions.getNotificacaosSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function tipoSugestaoGravar(data) {
  return async () => {
    try {
      const response = await http.post("/tipoDenuncia", data);

      dispatch(slice.actions.getNotificacaosSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAlltipoReclamacaoNivel2(sedeID, tipoDenunciaID, tipoReclamacaoLigaID, tipoMovimento) {
  return async () => {
    try {
      const response = await http.get(
        `/tipoDenunciaNivel2?sedeID=${sedeID}&tipoDenunciaID=${tipoDenunciaID}&tipoReclamacaoLigaID=${tipoReclamacaoLigaID}&tipoMovimento=${tipoMovimento}`
      );
      dispatch(slice.actions.getTipoReclamacaoNivel2(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function tipoReclamacaoDelete(id) {
  return async () => {
    try {
      const response = await http.delete(`/tipoDenuncia/${id}`);
      dispatch(slice.actions.getNotificacaosSuccess(response.data));
      // getAlltipoReclamacao(sedeID)
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

